import { v4 as uuidv4 } from "uuid";

/**
 * Mints the id that ties a browser pixel event to its Conversions API twin.
 *
 * Meta deduplicates on `(event_name, event_id)`, so the browser and the backend
 * must send the *same* id for one add-to-cart. The browser is the only side that
 * can mint it: the backend event is built later, from the analytics row this id
 * is written onto.
 *
 * Uses `uuid` rather than `crypto.randomUUID`, which is undefined in insecure
 * contexts (the app is served over plain HTTP on `*.prepit.local` in dev) and on
 * older Safari. `uuid` is already a production dependency on the cart path.
 */
export const createMetaEventId = (): string => uuidv4();
